import gql from 'graphql-tag';

export let CREATE_PROJECT_MUTATION = gql`
  mutation CreateProjectMutation(
    $name: String!
    $url: String!
    $clientEmail: String!
    $clientPassword: String!
  ) {
    createProject(
      name: $name
      url: $url
      clientEmail: $clientEmail
      clientPassword: $clientPassword
    ) {
      name
      url
    }
  }
`;

export let DELETE_PROJECT_MUTATION = gql`
  mutation DeleteProjectMutation($id: String!) {
    deleteProject(id: $id) {
      message
    }
  }
`;

export let UPDATE_PROJECT_MUTATION = gql`
  mutation UpdateProjectMutation(
    $idProject: String!
    $name: String!
    $url: String!
    $clientEmail: String!
    $clientPassword: String!
  ) {
    updateProject(
      idProject: $idProject
      name: $name
      url: $url
      clientEmail: $clientEmail
      clientPassword: $clientPassword
    ) {
      message
    }
  }
`;

export let RESTORE_PROJECT_MUTATION = gql`
  mutation RestoreProjectMutation($id: String!) {
    restoreProject(id: $id) {
      message
    }
  }
`;
